<template>
  <div class="send-cv-form">
    <h2>{{ headerTitle }}</h2>

    <div class="socialBox" v-if="false">
      <ul class="social-wrap">
        <li><a class="fb" href="#">Facebook</a></li>
        <li><a class="tw" href="#">Twitter</a></li>
        <li><a class="li" href="#">LinkedIn</a></li>
      </ul>
    </div>
    <form @submit.prevent="storeResume()" class="form">
      

      <div class="inp-group">
        <label :class="{'red': nameError}" for="name" ref="nameInput">
          <span v-if="!nameError">Name and surname</span>
          <span v-if="nameError">
                        <span v-if="!nameErrorText">Field name is required</span>
                        <span v-if="nameErrorText">{{ nameErrorText }}</span>
                    </span>
        </label>
        <input class="inp-style inp-fw" id="name" type="text" v-model.trim="name">
      </div>

      <div class="inp-group">
        <label :class="{'red': emailError}" for="email" ref="emailInput">
          <span v-if="!emailError">E-mail</span>
          <span v-if="emailError">
                        <span v-if="!emailErrorText">Field E-mail is required</span>
                        <span v-if="emailErrorText">{{ emailErrorText }}</span>
                    </span>
        </label>
        <input class="inp-style inp-fw" id="email" type="email" v-model.trim="email">
      </div>

      <div class="inp-group">
        <label :class="{'red': departmentError}" ref="departmentInput">
          <span v-if="!departmentError">Department</span>
          <span v-if="departmentError">
                        <span v-if="!departmentErrorText">Choose department please</span>
                        <span v-if="departmentErrorText">{{ departmentErrorText }}</span>
                    </span>
        </label>
        <multiselect
          :allow-empty="false"
          :options="departmentsForSelect"
          :preselect-first="true"
          :searchable="false"
          :showNoResults="false"
          deselectLabel=""
          label="title"
          selectLabel=""
          selectedLabel=""
          track-by="id"
          v-model="department">
        </multiselect>
      </div>

      <div class="inp-group">
        <label :class="{'red': positionError}" for="position" ref="positionInput">
          <span v-if="!positionError">Position</span>
          <span v-if="positionError">
                        <span v-if="!positionErrorText">Field Position is required</span>
                        <span v-if="positionErrorText">{{ positionErrorText }}</span>
                    </span>
        </label>
        <input class="inp-style inp-fw" id="position" type="text" v-model.trim="position">
      </div>

      <div class="inp-group inp-group__textarea">
        <label :class="{'red': messageError}" for="message" ref="messageInput">
                    <span v-if="!messageError">
                        Message <span class="float-right">{{ currentMessageLength }}/{{ maxMessageLength }}</span>
                    </span>
          <span v-if="messageError">
                        <span v-if="!messageErrorText">Field Message is required</span>
                        <span v-if="messageErrorText">{{ messageErrorText }}</span>
                    </span>
        </label>
        <textarea
          @click="autoresize()"
          @input="checkMessageLength()"
          class="inp-style inp-fw"
          id="message"
          type="text"
          v-model="message">
                </textarea>
      </div>

      <div class="contacts__form-file">
        <input @change="setFileName($event)"
               class="inp-group__file"
               id="file"
               accept="application/msword, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
               ref="uploadFileInput"
               type="file">
        <label :class="{red: fileError}" for="file">
          <span v-if="!uploadFileName && !fileError">
              Attach CV (Maximum file size: 10 Mb, formats: doc, docx, pdf)
          </span>
          <span v-if="fileError">
              <span v-if="!fileErrorText">Attachment size exceeds the allowable limit.</span>
              <span v-if="fileErrorText">{{ fileErrorText }}</span>
          </span>
          <span v-if="uploadFileName && !fileError">
              {{ uploadFileName }}
              <i @click.prevent="resetUploadFile()">&times;</i>
          </span>
        </label>
      </div>

      <div class="contacts__form-checkbox">
        <input class="inp-group__checkbox"
               id="styled-checkbox"
               type="checkbox"
               v-model="accept">
        <label :class="{red: acceptError}" for="styled-checkbox">
          <span class="checkbox"></span>
          <span v-if="!acceptError">I have read and accept the <a
            :href="`/${lang}/page/data-protection-additional-information`" target="_blank">
              Data protection Information</a> clause
          </span>
          <span v-if="acceptError">
              Check it please
          </span>
        </label>
      </div>

      <div class="contacts__form-btn">
        <button
          :class="{'btn-gray': !this.accept, 'btn-green': this.accept, 'btn-red': btnError}"
          :disabled="!this.accept || this.loading"
          class="btn btn-block">
          <span v-if="!complete">Send</span>
          <span v-if="complete && !btnError">Done</span>
          <span v-if="complete && btnError">
              <span v-if="!btnErrorText">Check form please</span>
              <span v-if="btnErrorText">
                  {{ btnErrorText }}
              </span>
          </span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapActions} from "vuex";

export default {
  name: "CVFormComponent",
  props: ['departments', 'lang', 'departmentsForSelect', 'title', 'vacancy'],
  components: {Multiselect},
  mounted() {
    if (!this.title) {
      this.headerTitle = 'Send us your CV'
    } else {
      this.headerTitle = this.title
    }

    if (this.vacancy) {
      if (this.vacancy.department_id) {
        this.department = [...this.departmentsForSelect].filter(item => {
          return item.id == this.vacancy.department_id
        })
      }

      if (this.vacancy.title) {
        this.position = this.vacancy.title
      }
    }
  },
  data: () => ({
    headerTitle: null,
    uploadFile: null,
    accept: false,
    name: '',
    email: '',
    position: '',
    nameError: false,
    nameErrorText: null,
    emailError: false,
    emailErrorText: null,
    positionError: false,
    positionErrorText: null,
    departmentError: false,
    departmentErrorText: null,
    messageError: false,
    messageErrorText: null,
    fileError: false,
    fileErrorText: null,
    acceptError: false,
    complete: false,
    btnError: false,
    btnErrorText: null,
    loading: false,
    uploadFileName: null,
    maxMessageLength: 999,
    currentMessageLength: 0,
    message: '',
    department: null,
  }),
  methods: {
    ...mapActions(['storeCV']),
    storeResume() {
      this.loading = true
      this.resetErrors()
      if (this.validateInput()) {
        let formData = new FormData();
        if (this.uploadFile) {
          formData.append("file", this.uploadFile);
        }
        formData.append("name", this.name);
        formData.append("email", this.email);
        formData.append("position", this.position || null);
        formData.append("department_id", this.department.id);
        formData.append("message", this.message);

        let data = {}

        data.path = this.$path
        data.cv = formData

        this.storeCV(data).then(() => {
          this.clearForm()
          this.showDone();
        }).catch(err => {
          let btnError = null
          if (err.hasOwnProperty('response') && err.response.status === 422) {

            for (let field of Object.keys(err.response.data.errors)) {
              if (field === 'file') {
                this.fileError = true
                this.fileErrorText = err.response.data.errors[field][0]
              }
              if (field === 'message') {
                this.messageError = true
                this.messageErrorText = err.response.data.errors[field][0]
              }
              if (field === 'name') {
                this.nameError = true
                this.nameErrorText = err.response.data.errors[field][0]
              }
              if (field === 'email') {
                this.emailError = true
                this.emailErrorText = err.response.data.errors[field][0]
              }
              if (field === 'position') {
                this.positionError = true
                this.positionErrorText = err.response.data.errors[field][0]
              }
              if (field === 'department_id') {
                this.departmentError = true
                this.departmentErrorText = err.response.data.errors[field][0]
              }
            }
          } else if (err.hasOwnProperty('response') && err.response.status === 429) {
            btnError = 'Too many attempts'
          }
          this.showDone(true, btnError);
        })
      } else {
        this.showDone(true);
      }
    },
    clearForm() {
      this.name = ''
      this.email = ''
      this.department = this.departmentsForSelect[0]
      this.position = ''
      this.message = ''
      this.resetUploadFile()
    },
    showDone(error = false, btnText = null) {
      this.complete = true
      this.loading = false

      if (error) {
        this.btnError = true
      }

      if (btnText) {
        this.btnErrorText = btnText
      }

      setTimeout(() => {
        this.complete = false
        this.btnError = false
        this.btnErrorText = null
      }, 4000)
    },
    resetErrors() {
      this.nameError = false
      this.nameErrorText = null
      this.emailError = false
      this.emailErrorText = null
      this.positionError = false
      this.positionErrorText = null
      this.departmentError = false
      this.departmentErrorText = null
      this.messageError = false
      this.messageErrorText = null
      this.fileError = false
      this.fileErrorText = null
      this.acceptError = false
    },
    validateInput() {
      if (this.name.length === 0) {
        this.nameError = true
      }

      if (this.email.length === 0) {
        this.emailError = true
      }

      if (this.message.length === 0) {
        this.messageError = true
      }

      if (!this.department || !this.department.id) {
        this.departmentError = true
      }

      if (!this.accept) {
        this.acceptError = true
      }

      if (this.uploadFile) {
        this.fileError = this.uploadFile.size / 1000 > 10240
      }

      setTimeout(() => {
        this.resetErrors()
      }, 5000)

      return !(this.nameError
        || this.emailError
        || this.messageError
        || this.departmentError
        || this.acceptError
        || this.fileError)
    },
    setFileName(event) {
      if (event.target.files.length > 0) {
        this.uploadFileName = event.target.files[0].name
        this.uploadFile = event.target.files[0]
      }
      if (!this.validateFileName(this.uploadFileName)) {
        this.fileErrorText = 'The file must be a file of type: docx, doc, pdf.'
        this.fileError = true;
        setTimeout(() => {
          this.resetErrors()
        }, 5000)
        this.resetUploadFile()
      }
    },
    validateFileName(fileName) {
      return ['doc', 'docx', 'pdf'].indexOf(fileName.split(/\./).pop()) !== -1
    },
    resetUploadFile() {
      const input = this.$refs.uploadFileInput
      input.type = 'text'
      input.type = 'file'
      this.uploadFileName = null
      this.uploadFile = null
    },
    checkMessageLength() {
      this.currentMessageLength = this.message.length
      if (this.currentMessageLength + 1 > this.maxMessageLength) {
        this.message = this.message.substring(0, 999);
        this.currentMessageLength = this.message.length
      }
    },
    autoresize() {
      let resizingTextareaInputs = [].slice.call(document.querySelectorAll('textarea[autoresize]'));

      resizingTextareaInputs.forEach(function (textarea) {
        textarea.addEventListener('input', autoresize, false);
      });

      function autoresize() {
        this.style.height = 'auto';
        this.style.height = this.scrollHeight + 'px';
        this.scrollTop = this.scrollHeight;
      }
    },
  }
}
</script>

<style scoped>
.send-cv-form {
  max-width: 760px;
  width: 100%;
  margin-top: 62px;
}

.socialBox {
  margin-bottom: 62px;
}

.red,
.red span {
  color: #E41B1B;
}

.btn-red {
  background: #E41B1B;
  color: white;
}

.contacts__form-file {
  margin-bottom: 20px;
  cursor: pointer;
  height: 30px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  background: url(/assets/images/clip.svg) left center no-repeat;
}

.send-cv-form .contacts__form-file label {
  display: block;
  margin: auto auto auto 0;
  padding-left: 25px;
  cursor: pointer;
}

.send-cv-form .contacts__form-file label i {
  font-size: 25px;
  position: relative;
  top: 4px;
  cursor: pointer;
}

.inp-group__file {
  display: none;
}

.send-cv-form form {
  max-width: 500px;
}
</style>

<style>
.send-cv-form .multiselect__tags {
  min-height: 45px;
  padding: 12px 40px 0 8px;
  border: 1px solid #f9f9f9;
  background: #f9f9f9;
}

.send-cv-form .multiselect__tags .multiselect__single {
  background-color: transparent;
}
</style>
